module.exports = __webpack_public_path__ + "img/ccc.1e02a9aa.png";